//@ts-nocheck directive
import React, { useState } from "react";
import { UpdateUserProfileType } from "../Types/userProfile";
//import MemberFred from "../../Images/Fred3.jpg";
import styles from "./AITools.module.css";

import "../lib/RequireUser/index.css";
import { useNavigate } from "react-router-dom";
import { getDatabase, ref, set } from "firebase/database";
import { auth, app } from "../lib/firebase";
import { doc, getFirestore, updateDoc } from "firebase/firestore";

import WelcomePage from "../WelcomePage/WelcomePage";
import { useAuthState } from "react-firebase-hooks/auth";
//import { updateProfile } from "firebase/auth";

import Consensus from "../../Images/Consensus.jpg";
import Scispace from "../../Images/Scispace.jpg";
import Keenious from "../../Images/Keenious.jpg";
import Undermind from "../../Images/Undermind.jpg";
import ResearchRabbit from "../../Images/ResearchRabbit.jpg";
import OpenKnowledgeMaps from "../../Images/OpenKnowledgeMaps.jpg";
import Litmaps from "../../Images/Litmaps.jpg";
import ConnectedPapers from "../../Images/ConnectedPapers.jpg";
import Gamma from "../../Images/Gamma.jpg";
import SlidesGo from "../../Images/SlidesGo.jpg";
import Julius from "../../Images/Julius.jpg";
import Napkin from "../../Images/Napkin.jpg";
import Anthropic from "../../Images/Anthropic.jpg";
import CopilotLab from "../../Images/CopilotLab.jpg";
import AIForEducation from "../../Images/AIForEducation.jpg";
import GitHub from "../../Images/GitHub.jpg";
import NotebookLM from "../../Images/NotebookLM.jpg";
import ZOC from "../../Images/ZOC.jpg";
import Valerie from "../../Images/Valerie.jpg";

interface IProps {
  userProfile: UpdateUserProfileType;
}

var bodyStyles = document.body.style;

var filePath = "";

var tempUID = localStorage.getItem("userUID")!;

function AIToolsInformation({ userProfile }: IProps) {
  //const tempUID: string = localStorage.getItem("userUID")!;
  const docID = userProfile;
  const db = getFirestore();

  const [userAILink1, setUserAILink1] = useState(userProfile.userAILink1);
  const [userAILink2, setUserAILink2] = useState(userProfile.userAILink2);
  const [userAILink3, setUserAILink3] = useState(userProfile.userAILink3);
  const [userAILink4, setUserAILink4] = useState(userProfile.userAILink4);

  const [userUID, setUserUID] = useState(tempUID);

  const saveUserProfileChanges: (
    arg0: string,
    arg1: string,
    arg2: string,
    arg3: string
  ) => void = () => {
    const docRef = doc(db, "userProfiles", userProfile.id);

    if (userAILink1 != "") {
      updateDoc(docRef, {
        userAILink1: userAILink1,
      });
    } else if (userAILink1 !== "") {
      updateDoc(docRef, {
        userAILink1: userAILink1,
      });
    } else {
      updateDoc(docRef, {
        userAILink1: "",
      });
    }

    if (userAILink2 != "") {
      updateDoc(docRef, {
        userAILink2: userAILink2,
      });
    } else if (userAILink2 !== "") {
      updateDoc(docRef, {
        userAILink2: userAILink2,
      });
    } else {
      updateDoc(docRef, {
        userAILink2: "",
      });
    }

    if (userAILink3 != "") {
      updateDoc(docRef, {
        userAILink3: userAILink3,
      });
    } else if (userAILink3 !== "") {
      updateDoc(docRef, {
        userAILink3: userAILink3,
      });
    } else {
      updateDoc(docRef, {
        userAILink3: "",
      });
    }

    if (userAILink4 != "") {
      updateDoc(docRef, {
        userAILink4: userAILink4,
      });
    } else if (userAILink4 !== "") {
      updateDoc(docRef, {
        userAILink4: userAILink4,
      });
    } else {
      updateDoc(docRef, {
        userAILink4: "",
      });
    }

    changeSaveButtonOff();
  };

  function changeSaveButtonOn() {
    bodyStyles.setProperty("--btn-inactive-text", "black");
    bodyStyles.setProperty("--btn-inactive-back", "rgb(175, 201, 250)");
    bodyStyles.setProperty("--btn-inactive-ptr", "pointer");
    bodyStyles.setProperty("--btn-inactive-hv", "rgba(175, 201, 250, 0.758)");
    bodyStyles.setProperty("--btn-inactive-tr", "0.7s");
  }

  function changeSaveButtonOff() {
    bodyStyles.setProperty("--btn-inactive-text", "rgba(129, 142, 164, 0.913)");
    bodyStyles.setProperty("--btn-inactive-back", "rgb(200, 212, 235)");
    bodyStyles.setProperty("--btn-inactive-ptr", "default");
    bodyStyles.setProperty("--btn-inactive-hv", "rgb(200, 212, 235)");
    bodyStyles.setProperty("--btn-inactive-tr", "0s");
  }

  return (
    <>
      <div className={styles.wrapper}>
        <div className={styles.top}>
          <h1 className={styles.header} style={{ marginRight: 30 }}>
            AI Tools
          </h1>
          &emsp;
          <button
            className={styles.saveButton}
            onClick={() =>
              saveUserProfileChanges(
                userAILink1,
                userAILink2,
                userAILink3,
                userAILink4
              )
            }
          >
            Save
          </button>
          <a href="WelcomePage" className={styles.closeAnchor}>
            <button className={styles.closeButton} style={{ marginRight: 70 }}>
              {" "}
              Close{" "}
            </button>
          </a>
          <h4 style={{ marginRight: 10, marginTop: 8 }}>Courtesy of </h4>
          <img src={Valerie} title="Valerie" />
        </div>
        <br />
        <h3>Literature Review</h3>
        <div>
          <div className={styles.imgContainer}>
            <a href="https://consensus.app/" target="_blank">
              <img src={Consensus} title="Consensus" />
              &emsp;
            </a>
          </div>
          <div className={styles.imgContainer}>
            <a href="https://typeset.io/" target="_blank">
              <img src={Scispace} title="Scispace" />
              &emsp;
            </a>
          </div>
          <div className={styles.imgContainer}>
            <a href="https://keenious.com/" target="_blank">
              <img src={Keenious} title="Keenious" />
              &emsp;
            </a>
          </div>
          <div className={styles.imgContainer}>
            <a href="https://www.undermind.ai/home/" target="_blank">
              <img src={Undermind} title="Undermind" />
              &emsp;
            </a>
          </div>
        </div>
        <br />
        <h3>Research Field Mapping</h3>
        <div>
          <div className={styles.imgContainer}>
            <a href="https://www.researchrabbit.ai/" target="_blank">
              <img src={ResearchRabbit} title="ResearchRabbit" />
              &emsp;
            </a>
          </div>
          <div className={styles.imgContainer}>
            <a href="https://openknowledgemaps.org/" target="_blank">
              <img src={OpenKnowledgeMaps} title="OpenKnowledgeMaps" />
              &emsp;
            </a>
          </div>
          <div className={styles.imgContainer}>
            <a href="https://www.litmaps.com/" target="_blank">
              <img src={Litmaps} title="Litmaps" />
              &emsp;
            </a>
          </div>
          <div className={styles.imgContainer}>
            <a href="https://www.connectedpapers.com/" target="_blank">
              <img src={ConnectedPapers} title="ConnectedPapers" />
              &emsp;
            </a>
          </div>
        </div>
        <br />
        <h3>Visualizations</h3>
        <div>
          <div className={styles.imgContainer}>
            <a href="https://gamma.app/" target="_blank">
              <img src={Gamma} title="Gamma" />
              &emsp;
            </a>
          </div>
          <div className={styles.imgContainer}>
            <a href="https://slidesgo.com/ai-presentations" target="_blank">
              <img src={SlidesGo} title="SlidesGo" />
              &emsp;
            </a>
          </div>
          <div className={styles.imgContainer}>
            <a href="https://julius.ai/" target="_blank">
              <img src={Julius} title="Julius" />
              &emsp;
            </a>
          </div>
          <div className={styles.imgContainer}>
            <a href="https://www.napkin.ai/" target="_blank">
              <img src={Napkin} title="Napkin" />
              &emsp;
            </a>
          </div>
        </div>
        <br />
        <h3>Prompt Libraries</h3>
        <div>
          <div className={styles.imgContainer}>
            <a
              href="https://docs.anthropic.com/en/resources/prompt-library/library"
              target="_blank"
            >
              <img src={Anthropic} title="Anthropic" />
              &emsp;
            </a>
          </div>
          <div className={styles.imgContainer}>
            <a
              href="https://copilot.cloud.microsoft/en-US/prompts"
              target="_blank"
            >
              <img src={CopilotLab} title="CopilotLab" />
              &emsp;
            </a>
          </div>
          <div className={styles.imgContainer}>
            <a
              href="https://www.aiforeducation.io/prompt-library"
              target="_blank"
            >
              <img src={AIForEducation} title="AIForEducation" />
              &emsp;
            </a>
          </div>
          <div className={styles.imgContainer}>
            <a
              href="https://github.com/microsoft/prompts-for-edu"
              target="_blank"
            >
              <img src={GitHub} title="GitHub" />
              &emsp;
            </a>
          </div>
        </div>
        <br />
        <h3>Note Taking</h3>
        <div>
          <div className={styles.imgContainer}>
            <a href="https://notebooklm.google/" target="_blank">
              <img src={NotebookLM} title="NotebookLM" />
              &emsp;
            </a>
          </div>
          <div className={styles.imgContainer}>
            <a href="https://zoc.ai/" target="_blank">
              <img src={ZOC} title="ZOC" />
              &emsp;
            </a>
          </div>
        </div>
        <div className={styles.userLabel}>
          <h3 style={{ marginLeft: -15, marginRight: 12 }}>
            Add your own link to websites. Type the name then press "Save". Then
            press the "Open" button.
          </h3>
          <br />
          <input
            style={{
              paddingLeft: 3,
              width: 400,
              marginLeft: 365,
            }}
            type="text"
            defaultValue={userProfile.userAILink1}
            onChange={(e) => {
              setUserAILink1(e.target.value);
              changeSaveButtonOn();
            }}
          />
          <a
            href={userProfile.userAILink1}
            target="_blank"
            style={{ display: "inline-grid" }}
          >
            <button
              style={{
                width: 50,
                display: "inline-grid",
                marginLeft: 10,
                backgroundColor: "Gainsboro",
                borderRadius: 10,
              }}
            >
              Open
            </button>
          </a>
        </div>

        <div className={styles.userLabel}>
          <input
            style={{
              paddingLeft: 3,
              width: 400,
              marginLeft: 365,
            }}
            type="text"
            defaultValue={userProfile.userAILink2}
            onChange={(e) => {
              setUserAILink2(e.target.value);
              changeSaveButtonOn();
            }}
          />
          <a
            href={userProfile.userAILink2}
            target="_blank"
            style={{ display: "inline-grid" }}
          >
            <button
              style={{
                width: 50,
                display: "inline-grid",
                marginLeft: 10,
                backgroundColor: "Gainsboro",
                borderRadius: 10,
              }}
            >
              Open
            </button>
          </a>
        </div>

        <div className={styles.userLabel}>
          <input
            style={{
              paddingLeft: 3,
              width: 400,
              marginLeft: 365,
            }}
            type="text"
            defaultValue={userProfile.userAILink3}
            onChange={(e) => {
              setUserAILink3(e.target.value);
              changeSaveButtonOn();
            }}
          />
          <a
            href={userProfile.userAILink3}
            target="_blank"
            style={{ display: "inline-grid" }}
          >
            <button
              style={{
                width: 50,
                display: "inline-grid",
                marginLeft: 10,
                backgroundColor: "Gainsboro",
                borderRadius: 10,
              }}
            >
              Open
            </button>
          </a>
        </div>

        <div className={styles.userLabel}>
          <input
            style={{
              paddingLeft: 3,
              width: 400,
              marginLeft: 365,
            }}
            type="text"
            defaultValue={userProfile.userAILink4}
            onChange={(e) => {
              setUserAILink4(e.target.value);
              changeSaveButtonOn();
            }}
          />
          <a
            href={userProfile.userAILink4}
            target="_blank"
            style={{ display: "inline-grid" }}
          >
            <button
              style={{
                width: 50,
                display: "inline-grid",
                marginLeft: 10,
                backgroundColor: "Gainsboro",
                borderRadius: 10,
              }}
            >
              Open
            </button>
          </a>
        </div>
      </div>
    </>
  );
}

export default AIToolsInformation;
